/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {
  BsFacebook,
  BsGithub,
  BsStackOverflow,
  BsTwitter
} from "react-icons/bs";
import { FaLinkedin } from "react-icons/fa";
import { SiGooglemessages } from "react-icons/si";
import { Link } from "react-router-dom";
import logo from "../../images/logo1.png";




function OnlyFooter() {
  return (
    <>
        <div className="footer-contact-wrapper contact_footer">
<div className="footer-items-section padding_container ">
  <div className="footer-items">
    <div className="item logo-item">
      <div className="logo">
      <img style={{width: "96px", height: "50px"}} src={logo} alt="" />
      </div>
      <div className="logo-text">
        Here, I provided my social media links. Before going to a
        argument you firstly contact me.
      </div>
      <div className="logo-svg">
              <a target="_blank" rel="noreferrer" href="https://www.facebook.com/iasraful1971">
                <BsFacebook />
              </a>
              <a  target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/as-dev">
                <FaLinkedin />
              </a>
              <a href="https://twitter.com/asl_dev"  target="_blank" rel="noreferrer">
                <BsTwitter />
              </a>
              <a   target="_blank" rel="noreferrer" href="https://github.com/iasraful1971">
                <BsGithub />
              </a>
              <a  target="_blank" rel="noreferrer" href="https://stackoverflow.com/users/16839821/asraful">
                <BsStackOverflow />
              </a>
            </div>
      <a href="mailto:iasraful107@gmail.com" className="message-btn">
        <button>
          <SiGooglemessages size={20} /> Contact Me
        </button>
      </a>
    </div>

    <div className="item">
      <h3>Useful Links</h3>
      <ul>
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <Link to="/about-me">About Me</Link>
        </li>
        <li>
          <Link to="/portfolio">Portfolio</Link>
        </li>
        <li>
          <Link to="/blogs">Articles</Link>
        </li>
        <li>
          <Link to="/service">Services</Link>
        </li>
        <li>
          <Link to="/pricing">Pricing</Link>
        </li>
      </ul>
    </div>

    <div className="item">
      <h3>Terms & conditions</h3>
      <ul>
      <li>
          <Link to="/register">Account</Link>
        </li>
        <li>
          <Link to="/policy">Privacy & policy</Link>
        </li>
        <li>
          <Link to="/contact">Contact Me</Link>
        </li>
        <li>
          <Link to="/policy">Refund Policy</Link>
        </li>
      </ul>
    </div>
    <div className="item">
      <h3>Address</h3>
      <ul>
        <li>
          <p>
            <a href="#">Gazipur, Dhaka, Bangladesh</a>
          </p>
        </li>
        <li>
          <p>
            <a href="tel:+8801758015756">+8801758015756</a>
          </p>
        </li>
        <li>
          <p>
            <a href="mailto:iasraful107@gmail.com">
              iasraful107@gmail.com
            </a>
          </p>
        </li>
      </ul>
    </div>
  </div>
</div>

<div className="copyright padding_container">
  <hr />
  <br />
  <span>
    Designed & Developed by{" "}
    <span className="green"> Muhammad Asraful</span>
  </span>
</div>
</div>
    </>
  )
}

export default OnlyFooter